import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import dateFormat from "dateformat";

// Icons
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useNavigate } from "react-router-dom";

const UsersRow = ({ row, index }) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const [statusBackgroundColor, setStatusBackgroundColor] = useState(null);
  const [statusColor, setStatusColor] = useState(null);

  useEffect(() => {
    if (row.status === "Active") {
      setStatusColor("#14a44d");
      setStatusBackgroundColor("rgba(20, 164, 77, 0.2)");
    } else if (row.status === "Banned") {
      setStatusColor("#ff0000");
      setStatusBackgroundColor("rgba(255, 0, 0, 0.2)");
    } else if (row.status === "deleted") {
      setStatusColor("#e4a11b");
      setStatusBackgroundColor("rgba(240, 172, 78, 0.2)");
    }
  }, []);

  return (
    <React.Fragment>
      <TableRow>
        <TableCell>
          <p style={{ fontWeight: 500, fontSize: "13px" }}>{++index}</p>
        </TableCell>
        {/* <TableCell>
          <p style={{ fontWeight: 500, fontSize: "13px" }}>#{row._id}</p>
        </TableCell> */}
        <TableCell component="th" scope="row">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <p style={{ fontWeight: 500, fontSize: "15px" }}>{row.fullName}</p>
          </div>
        </TableCell>

        <TableCell>
          <p style={{ fontWeight: 500, fontSize: "14px" }}>{row.email}</p>
        </TableCell>
        <TableCell>
          <p style={{ fontWeight: 500, fontSize: "14px" }}>{row.phoneNumber}</p>
        </TableCell>
        <TableCell>
          <div>
            <p style={{ fontWeight: 500, fontSize: "14px" }}>
              {dateFormat(new Date(row.joiningDate), "mmm dd, yyyy")}
            </p>
            <p
              style={{
                color: "hsl(240, 1%, 48%)",
                fontSize: "13px",
                fontWeight: 500,
              }}
            >
              {dateFormat(new Date(row.joiningDate), "hh:MM TT")}
            </p>
          </div>
        </TableCell>
        <TableCell>
          <p style={{ fontWeight: 500, fontSize: "14px" }}>
            {row.gender}
            {/* {row.gender ? (row.gender === "M" ? "Male" : "Female") : "undefine"} */}
          </p>
        </TableCell>
        {/* status */}
        <TableCell>
          <p
            style={{
              background: statusBackgroundColor && statusBackgroundColor,
              color: statusColor && statusColor,
              fontWeight: 700,
              fontSize: "14px",
              maxWidth: "fit-content",
              padding: "3px 7px",
              borderRadius: "7px",
            }}
          >
            {row.status}
          </p>
        </TableCell>
        {/* status */}

        <TableCell>
          <IconButton
            onClick={() => navigate(`${row._id}/${row.fullName}/profile`)}
          >
            <VisibilityIcon />
          </IconButton>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
};

UsersRow.propTypes = {
  row: PropTypes.shape({
    // sno: PropTypes.number.isRequired,
    _id: PropTypes.string.isRequired,
    fullName: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    phoneNumber: PropTypes.string.isRequired,
    joiningDate: PropTypes.string.isRequired,
    gender: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
  }).isRequired,
};

export default UsersRow;
